import {UIGameBaseAchievementView} from './UIGameBaseAchievementView'
import {UIGameManager} from '../UIGameManager'
import {InGameAchievement} from './UIGameAchievementController'

export class UIGameCityImprovementAchievementView extends UIGameBaseAchievementView {
    constructor(options: InGameAchievement, uiGameManager: UIGameManager, x: number, y: number, w: number, h: number, avatarSize: number) {
        super(options, uiGameManager, x, y, w, h, avatarSize)
        this.titleSection.createTitle()
        this.titleSection.createAchievementIcon()

        const descriptionX = this.margin
        const descriptionY = this.margin
        const width = this.descriptionSection.width - descriptionX - this.margin
        const height = this.margin
        this.descriptionSection.createDescriptionText(descriptionX, descriptionY, width, height)
        this.drawBackground()
    }
}
